import React from 'react';
import { useForm } from "react-hook-form";

const CustomNewsLetter = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: "onBlur"
    });

    const onSubmit = (data) => {
        const config = {
            SecureToken: "118c3d49-ce2a-4e28-998f-cb1a17538acd",
            To: 'commons@tetrahed.com',
            From: "contactus@tetrahed.com",
            Subject: "New user subscribed for Newsletter",
            Body: `Email ID for the user: ${data.emailId}`
        };

        try {
            window.Email.send(config).then(
                (message) => {
                    if (message === 'OK') {
                        alert("You have successfully subscribed to our newsletter");
                        reset(); // Reset form on success
                    } else {
                        alert("Oops, something went wrong. Please try again later.");
                    }
                }
            );
        } catch (error) {
            alert('Oops, something went wrong.');
            console.error('Error sending email:', error);
        }
    };

    return (
        <div className="newsletter-form" data-aos="fade-up" data-aos-delay="300">
            <form onSubmit={handleSubmit(onSubmit)}>
                <input
                    id="mc-form-email"
                    className="email"
                    type="email"
                    placeholder="Enter your email address"
                    {...register("emailId", {
                        required: 'Email is required',
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            message: "Invalid email address"
                        }
                    })}
                />
                <button className="btn btn-brand-color btn-hover-secondary" type="submit">Subscribe</button>
            </form>
            {errors.emailId && <p style={{ color: 'red' }}>{errors.emailId.message}</p>}
        </div>
    );
}

export default CustomNewsLetter;
